import { Component } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { FeatureService } from '@app/services/feature.service';

@Component({
    templateUrl: './payroll-landing.template.html',
    styleUrls: ['./payroll-landing.style.scss'],
})
export class PayrollLandingView {
    isUnderMaintenance = false;

    constructor(
        private featureService: FeatureService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        this.featureService.has(FeatureFlag.payrollMaintenance).then((hasFlag: boolean) => {
            this.isUnderMaintenance = hasFlag;
        });
    }
}
